/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Edit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Edit"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      fillRule="evenodd"
      d="M19.861 2.917a3.13 3.13 0 0 0-4.426 0L4.74 13.612a3.1 3.1 0 0 0-.756 1.223l-1.93 5.792a1.043 1.043 0 0 0 1.32 1.32l5.791-1.931a3.1 3.1 0 0 0 1.223-.756L21.083 8.565a3.13 3.13 0 0 0 0-4.426zm-2.95 1.475a1.043 1.043 0 0 1 1.475 0l1.222 1.222a1.043 1.043 0 0 1 0 1.475l-9.784 9.784-2.697-2.697zM5.845 15.846l-1.153 3.461 3.46-1.153z"
      className="SVG"
      clipRule="evenodd"
    />
  </svg>
);

export const EditIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'edit-icon'}
      icon={Edit}
      {...props}
      size={size}
    />
  );
};
